module.exports = __webpack_public_path__ + "static/media/home_bg.e594ba48.png";